module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAECAYAAACUY/8YAAAAAXNSR0IArs4c6QAAAFhJREFUKFNjtI2euYIBDBhlINR/RggfDfxn0IHIM0Ll/1/Gro7xP1gZA8NTME1zC+xiZq4C2fSfgUEOm4sY/0Nc9J/hvxbUZUxQH18Bi+P0MeNjsHpaWwAAfIYpd6aQkjoAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/images/boss/delete.png
// module id = aqtf
// module chunks = 49